var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('a-rate',{attrs:{"tooltips":_vm.desc},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}}),_c('span',{staticClass:"ant-rate-text"},[_vm._v(_vm._s(_vm.desc[_vm.value - 1]))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }